import ExternalLinksBaseHandler from '../external_links_base_handler';
import ServiceFactory from '../../../../services/service_factory';
import {MEMBERSHIP_POST_ACTIONS} from "../membership/external_links_membership_handler_consts";
import {POST_ACTIONS} from "../../../../events/post_actions";
const PENDING_APPS_POST_ACTIONS = {
    CLOSE: 'pending' // no idea why they send 'pending' when they want to close the pending screen but it is what it is
};
export default class ExternalLinksPendingLoginHandler extends ExternalLinksBaseHandler {
    static CLASS = 'ExternalLinksPendingLoginHandler';
    static HandlerName = 'pending_login';

    executePostMessageAction(postMessageData) {
        //Actions that need with auto login before
        if (postMessageData.Token) {
            this.close();
            ServiceFactory.create().oAuth2Service().runAutoLogin(postMessageData.Token).then(()=> {
                if(postMessageData.ActionId) {
                    switch (postMessageData.ActionId.toString()) {
                        case MEMBERSHIP_POST_ACTIONS.UPLOAD_DOCUMENTS_IV:
                            this.close(POST_ACTIONS.CLOSE);
                            this._handleUploadDocumentsIv();
                            break;
                        default:
                            this.logger.warn('Not supported ActionID. ActionID = ' + postMessageData.ActionId);
                            break;
                    }
                }
            });
        }
        else{
            //action without Auto login
            switch (postMessageData.ActionId.toString().toLowerCase()) {
                case MEMBERSHIP_POST_ACTIONS.SHOW_LOGIN:
                    this.close();
                    this.handleOpenWebLogin();
                    break;
                case PENDING_APPS_POST_ACTIONS.CLOSE:
                    this.close();
                    break;
                default:
                    this.logger.warn('Not supported ActionID. ActionID = ' + postMessageData.ActionId);
                    break;
            }
        }
    }

    getHandlerName() {
        return ExternalLinksPendingLoginHandler.HandlerName;
    }
}